
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PerfisServicosModel } from '../model/perfis-servicos.model';
import { RegistroService } from '../services/registro.service';
import { EntradaIsoFugModel } from '../model/dados-iso-fug.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { CertificadoService } from '../services/certificado.service';
import DadosCertificadoModel from '../model/dados-certificado.model';

@Component({
  selector: 'app-seleciona-perfil',
  templateUrl: './seleciona-perfil.component.html',
  styleUrls: ['./seleciona-perfil.component.css']
})
export class SelecionaPerfilComponent implements OnInit {

  @Output() perfilSelecionadoEvent$ = new EventEmitter<PerfisServicosModel[]>();
  @Input() perfilAtual: DadosRegistroModel;
  @Input() dadosCert:  DadosCertificadoModel
  private perfilRevogacao: PerfisServicosModel;

  public formSelecionaPerfil: FormGroup;
  public perfis: PerfisServicosModel[];
  public criticaFugIso: any;
  
  constructor(
    private fb: FormBuilder,
    private registroService: RegistroService,
    private certificadoService: CertificadoService
  ) { }

   ngOnInit() {
    setTimeout(() => this.registroService.OnInit(), 1000);
    this.createForm();
    this.listaPerfisParaCertificado();
   
  }

  private createForm() {
    this.formSelecionaPerfil = this.fb.group(
      {
        perfilSelecionado: new FormControl()
      });
  }

  get perfilSelecionado() {
    return this.formSelecionaPerfil.get('perfilSelecionado');
  }

  private async listaPerfisParaCertificado() {

      let situacao;
      this.perfis = await this.registroService.listaPerfis();
      //Serparo o perfil para revogação..   
      let nuPerfilAtual = 0;      
      if(this.perfilAtual){
        nuPerfilAtual = this.perfilAtual.nu_perfil;
      }
      else
      {
        const dados = sessionStorage['dadosRegistro'];    
        const perfilDados =  undefined === dados || dados === "undefined" ? undefined : JSON.parse(dados);
        if (perfilDados) {
            nuPerfilAtual = perfilDados.nu_perfil;
            situacao =  perfilDados.situacao;
        }      
      }     
      if (nuPerfilAtual > 0) {
        this.perfilRevogacao = this.perfis.filter(p => +p.idPerfil === nuPerfilAtual)[0];
        if(this.perfilRevogacao === undefined){
          console.log("<RENOVAR REGISTRO> Registro de perfis Administrador e Gestor não podem ser Renovados")
        }
          //Remove o perfil atual da lista...   
        if (situacao !== undefined && situacao === 4)  
            this.perfis = this.perfis.filter(p => +p.idPerfil !== 14);
        else
           this.perfis = this.perfis.filter(p => +p.idPerfil !== 14 && +p.idPerfil !== nuPerfilAtual);   
      }
      else {
        this.perfis = this.perfis.filter(p => +p.idPerfil !== 14);
      }
    


       //Tratamento Token (TKN)
       const orgaoTkn = this.certificadoService.getOrgaoEmissor(this.dadosCert) !== undefined ? this.certificadoService.getOrgaoEmissor(this.dadosCert).trim():undefined
       if ( orgaoTkn === 'Caixa Economica Federal'){
         console.log('caiu no IF da critica TKN');
         this.perfis = this.perfis.filter(p => +p.idPerfil === 1); 
       }
      
  }

  public async validaPJPerfilRestrito(): Promise<boolean> {

    this.criticaFugIso = null;
    const perfilSelecionado = this.perfilSelecionado.value;
    //PJ..
    if (perfilSelecionado.tipoPerfil == 1) {

      let params: EntradaIsoFugModel = new EntradaIsoFugModel();
      params.perfilSelecionado = this.perfilSelecionado.value.idPerfil;
      //params.inscricao --> backend preenche com inscricao do certificado.

      const idPerfilSelecionado: number = perfilSelecionado.idPerfil;
      switch (idPerfilSelecionado) {

        //Cartório
        case 15:
          await this.registroService.consultaIsoServlet(params).then(data => {
            this.criticaFugIso = data;
          });
          break;
        //Inst. Financeira
        case 16:
        //Inst. Fiduciaria
        case 96:
        //Agente moradia  
        case 18:
          await this.registroService.consultaFugServlet(params).then(data => {
            this.criticaFugIso = data;
          });
          break;
      }
      return new Promise<boolean>(resolve => {
        resolve(this.criticaFugIso === null || 'S' === this.criticaFugIso['icPerfil']);
      });
    }

  }

  public async validaPerfil() {

    const perfilSelecionado = this.perfilSelecionado.value;

    perfilSelecionado.isValido = false;

    const valido = await this.validaPJPerfilRestrito().then(result => {
      perfilSelecionado.isValido = this.verificaIsPerfilValido();
      //Dispara evento q atualiza o atributo no component 'pai'.
      const perfis = [perfilSelecionado, this.perfilRevogacao];
      this.perfilSelecionadoEvent$.emit(perfis);
      return result;
    });
    return valido;
  }

  private verificaIsPerfilValido(): boolean {
    return this.perfilSelecionado.value &&
      (this.criticaFugIso === null || 'S' === this.criticaFugIso['icPerfil']);
  }

  get isPerfilValido(): boolean {
    return this.perfilSelecionado.value !== null && this.perfilSelecionado.value.isValido;
  }

  get isPerfilRestrito(): boolean {
    const perfil: PerfisServicosModel = this.perfilSelecionado.value;
    return perfil !== null && PerfisServicosModel.isRestrito(perfil);
  }

}